import { useEffect, useState } from "react";

export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      if (!delay) {
        setDebouncedValue(value);
        return;
      }
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      /** Cancel the timeout if value changes (also on delay change or unmount)
       * This is how we prevent debounced value from updating if value is changed ...
       * .. within the delay period. Timeout gets cleared and restarted.
       */
      // eslint-disable-next-line consistent-return
      return (): void => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );
  return delay ? debouncedValue : value;
}
